import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { ModulosController } from '../../modulos-controller';

import { TomadaDeContaService } from '../../../../providers/tce-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

@Component({
  selector: 'page-tce-nao-enviado',
  templateUrl: 'tce-nao-enviado.html',
  providers: [
    TomadaDeContaService
  ]
})
export class TCENaoEnviadoPage extends ModulosController {

  idModuloAnalise: any;
  listarDados = [];
  isJurisdicionado: any;
  comboFatoGerador: any = null;
  loading: boolean = true;
  page1: number = 1;
  filter: any = { nmSacc: '' };

  order1: string = 'nmSacc';
  reverse1: boolean = true;

  constructor(public navCtrl: NavController,
    public alertService: AlertService,
    public navParams: NavParams,
    public tomadaDeContaService: TomadaDeContaService,
    public gestaoPcaService: GestaoPcaService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.idModuloAnalise = this.navParams.get('analise').idModuloAnalise;
    this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    this.carregarDados();
    this.setModuloId(9);
  }

  setOrder1(value: string) {
      if (this.order1 === value) {
          this.reverse1 = false;
          this.order1 = "-" + value;
      } else {
          this.reverse1 = true;
          this.order1 = value;
      }
  }

  carregarDados() {

    this.listarDados = [];
    this.tomadaDeContaService.listarAnalisesTomadaDeContaNaoEnviadas().subscribe(data => {
      this.listarDados = data;
      this.loading = false;
    }, error => {
      this.loading = false;
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Houve um problema ao listar as Tomadas de Contas.");
    });
  }

  voltarParaTomadaDeconta() {
    this.menuService.redirecionarPagina(this.tomadaDeContaService.obterIdPaginaTomadaDeConta());
  }

  salvar() {
    this.loading = true;
    this.tomadaDeContaService.salvarAnaliseTCENaoEnviado(this.listarDados).subscribe(data => {
      this.alertService.mostraAlerta("", "Salvo com sucesso.");
      this.loading = false;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      this.loading = false;
    });
  }

  finalizar() {
    this.loading = true;
    this.tomadaDeContaService.finalizarAnaliseTCENaoEnviado(this.listarDados).subscribe(data => {
      this.alertService.mostraAlerta("", "Finalizada com sucesso.");
      this.voltarParaTomadaDeconta();
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
      this.loading = false;
    });
  }

  truncateText(text) {
    let numberOfWordsToTruncate = 2;

    if (text != undefined) {
      let separatedByWords = text.toString().split(" ");

      if (this.needTruncate(text)) {
        return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
      }
      else {
        return text;
      }
    }
  }

  needTruncate(text) {
    let separatedByWords;

    if (text != undefined) {
      separatedByWords = text.toString().split(" ");
    } else {
      separatedByWords = "A";
    }

    let numberOfWordsToTruncate = 2;

    return separatedByWords.length >= numberOfWordsToTruncate;
  }

  exibirCompleto(text) {
    this.alertService.mostraAlerta('', text);
  }

  formatarValorNumerico(valor) {

    if(isNaN(valor)){
      valor = 0
    }
    
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  calcularDiferencaData(item) {
    const year = item.dtLimite.substr(6, 4);
    const month = item.dtLimite.substr(3, 2);
    const day = item.dtLimite.substr(0, 2);
    const date = new Date(year, month, day);

    var date1 = new Date(date);

    var date2 = new Date(item.dtLimite.substr(6, 4), 12, 31);

    var timeDiff = date2.getTime() - date1.getTime();
    
    if (timeDiff > 0) {
      item.nmDiasAtrasados = Math.ceil(timeDiff / (1000 * 3600 * 24));
    } else {
      item.nmDiasAtrasados = 0;
    }

    return item.nmDiasAtrasados;
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/tce/tce-nao-enviado/tce-nao-enviado.ts